// extracted by mini-css-extract-plugin
export default {"joinHeadersec":"welcomeheader_joinHeadersec__b5PGj","menuSec":"welcomeheader_menuSec__xpW35","menuList":"welcomeheader_menuList__5bWPY"};